// extracted by mini-css-extract-plugin
module.exports = {"container":"passing-grade_container__1Xeo9"};